<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <leased-product-card />
    </div>



  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import moment from "moment";
  import LeasedProductCard from "../../components/LeasedProductCard";

  export default {
    components: {LeasedProductCard},
    computed:{
      ...mapGetters(['user','companies']),
      getType(){
        return this.$route.params.type
      }
    },
    mounted(){
      console.log(this.companies)
    },
    data () {
      return {
        moment,
        company:null,
        filterType:'now',
        cPage:1,
        releaseData: {},
        services:{},
        paymentData: {
          payment_date: moment().format('YYYY-MM-DD'),
        },
        fields: [
          { key: 'id', label: 'Sıra No' },
          { key: 'client.full_name', label: 'Müşteri Adı' },
          { key: 'client.phone', label: 'Telefonu' },
          { key: 'service.name', label: 'Ürün Adı' },
          { key: 'issue_date', label: 'Alış Tarihi' },
          { key: 'delivery_date', label: 'Teslim Edilmesi Gereken Tarih' },
          { key: 'price', label: 'Peşinat' },
          { key: 'total_price', label: 'Toplam Ücret' },
          { key: 'service.company.full_name', label: 'Bayi' },
          { key: 'actions', label: '', tdClass: 'text-right' },
        ],
      }
    },
    methods: {
      ...mapActions(['getLeasedProducts', 'createPayment', 'release']),
      releaseAction() {
        this.release(this.releaseData).then(response => {
          this.success(response.data.message);
          this.$refs.releaseModal.hide();
          this.refreshTable();
        }).catch(error => {
          this.error(error.response.data.message);
        })
      },
      releaseModal(id) {
        this.releaseData = {
          delivered_date: moment().format('YYYY-MM-DD'),
          lease_id: id,
          clear_credits: true,
        };
        this.$refs.releaseModal.show();
      },
      paymentAction() {
        this.createPayment(this.paymentData).then(response => {
          this.success(response.data.message);
          this.$refs.paymentModal.hide();
          this.refreshTable();
        }).catch(error => {
          this.error(error.response.data.message);
        });
      },
      paymentModal(id) {
        this.paymentData.lease_id = id;
        this.$refs.paymentModal.show();
      },
      hidePaymentModal() {
        this.paymentData = {
          payment_date: moment().format('YYYY-MM-DD'),
        };
      },
      refreshTable () {
        this.$refs.table.refresh()
      },
      getItems () {
        return this.getLeasedProducts({filterType:this.filterType,getType:this.getType,company:this.company,page:this.cPage})
          .then(data => data.data).then(response => {
            this.services={
              last_page:response.last_page
            }
            return response.data;
          })
      },
    }
  }
</script>
